<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <!-- <Nav :navbar="navbar"></Nav> -->
    <div class="list-wrap">
      <!-- 快速导航 -->
      <!-- <News :columnList="columnList"></News> -->
      <div class="title-wrap" v-if="columnList[0]">
        <img v-if="columnList[0]['strName'] === '通知公告'" src="../../assets/images/menu2.jpg" alt="">
        <img v-if="columnList[0]['strName'] === '会议要闻'" src="../../assets/images/menu3.jpg" alt="">
        <img v-if="columnList[0]['strName'] === '会议日程'" src="../../assets/images/menu4.jpg" alt="">
        <img v-if="columnList[0]['strName'] === '大会发言'" src="../../assets/images/menu5.jpg" alt="">
        <img v-if="columnList[0]['strName'] === '委员风采'" src="../../assets/images/menu6.jpg" alt="">
        <img v-if="columnList[0]['strName'] === '工作综述'" src="../../assets/images/menu7.jpg" alt="">
      </div>
      <!-- 列表 -->
      <div class="leader flex-box">
        <ul v-if="list.length > 0">
          <li
            class="flex flex-x-between flex-y-center"
            v-for="(item, index) in list"
            :key="index"
          >
            <span @click="detailHandle(item.strId)">{{ item.strMasTitle }}</span>
            <p>{{ item.strText }}</p>
          </li>
        </ul>
        <div v-else class="no-content">暂无数据</div>
        <div
          class="page-wrap flex flex-x-center flex-y-center"
          v-if="list.length > 0"
        >
          <p @click="getListData(1, true)">首页</p>
          <p @click="getListData(intCurPage <= 1 ? 1 : intCurPage - 1, false)">上一页</p>
          <p @click="getListData(intCurPage >= intPageCount ? intPageCount : intCurPage + 1, false)">下一页</p>
          <p @click="getListData(intPageCount, false)">尾页</p>
          <span>总记录数:<em>{{ intAllCount }}</em>,每页显示<em>{{ intPageSize }}</em>条记录,</span>
          <span>当前页：<i>{{ intCurPage }}</i>/<em>{{ intPageCount }}</em></span>
          <div>
            跳转至<a-input
              :value="input_value"
              @change="changeHandle"
              @pressEnter="pressEnter"
            />页
          </div>
          <b @click="pressEnter()">跳转</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/base/nav.vue";
import News from "@/components/base/news.vue";
import { listData } from "@/api/configuration";
import { get } from "../../utils/helpers";
export default {
  name: "List",
  components: {
    Nav,
    News,
  },
  props: {},
  data() {
    return {
      strId: "",
      navbar: [], // 面包屑导航
      columnList: [], //侧边导航
      list: [], // 列表
      input_value: 1, // 跳转至默认值1
      intAllCount: 0, // 总条数
      intPageSize: 0, // 每页条数
      intCurPage: 1, // 当前页
      intPageCount: 1, // 总页数
    };
  },
  watch: {
    $route(to, from) {
      this.getListData(1, true);
    },
  },
  created() {
    this.strId = this.$route.query.strId;
    this.getListData(1, true);
  },
  methods: {
    //获取列表数据
    getListData(page, refresh) {
      var param = {
        strColId: this.$route.query.strId,
        strWebSiteId: this.$route.query.strWebSiteId,
        intCurPage: page,
      };
      listData(param)
        .then((res) => {
          if (refresh) {
            this.columnList = get(["data", "objList", "columnList"], res.data); // 侧边导航
            this.list = get(["data", "objList", "infoList"], res.data); //列表
            this.intAllCount = get(["data", "objList", "intAllCount"], res.data);
            this.intPageSize = get(["data", "objList", "intPageSize"], res.data);
            this.intCurPage = get(["data", "objList", "intCurPage"], res.data);
            this.intPageCount = get(["data", "objList", "intPageCount"], res.data);
            //碎片导航
            this.navbar = [];
            for (let i in res.data.data.objList.colPathList) {
              this.navbar.push(res.data.data.objList.colPathList[i]);
            }
            this.navbar.splice(0, 1);
            // 设置title
            let length = this.navbar.length;
            document.title = this.navbar[length - 1].strName;
          } else {
            this.list = get(["data", "objList", "infoList"], res.data);
          }
        })
        .catch((err) => {
          this.$message.destroy();
          this.$message.error(err);
        });
    },

    // 输入框点击
    changeHandle(value) {
      this.input_value = value.data;
    },

    // 输入框按下Enter键
    pressEnter() {
      this.getListData(this.input_value, false);
    },

    // 跳转详情
    detailHandle(strId) {
      this.$router.push({ path: "/detail", query: { strId: strId, strWebSiteId: this.$route.query.strWebSiteId } });
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  width: 1200px;
  margin: 0 auto;
}
.list-wrap {
  margin: 8px auto 30px;
  .title-wrap {
    margin-top: 20px;
  }
}
.leader {
  box-sizing: border-box;
  padding: 0 50px;
  ul {
    margin-bottom: 40px;
    li {
      position: relative;
      margin: 0 0 20px 0;
      span {
        font-size: 20px;
        color: #b02023;
        line-height: 40px;
        font-weight: bold;
        cursor: pointer;
        &:hover {
          color: #1f5ac5;
        }
      }
      p {
        font-size: 15px;
        line-height: 25px;
        color: #4a4a4a;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        margin: 0;
      }
      i {
        font-style: normal;
        font-size: 16px;
        color: #999;
      }
    }
  }
  .no-content {
    text-align: center;
    box-sizing: border-box;
    padding: 100px 0;
  }
  .page-wrap {
    color: #4a4a4a;
    font-size: 16px;
    span {
      margin: 0 5px;
      i {
        display: inline-block;
        font-style: normal;
        font-weight: bold;
        color: red;
      }
      em {
        display: inline-block;
        font-style: normal;
        font-weight: bold;
      }
    }
    p {
      background-color: #f5f5f5;
      border-color: transparent;
      color: rgba(0,0,0,.7);
      border-width: 1px;
      cursor: pointer;
      justify-content: center;
      padding-bottom: calc(.5em - 1px);
      padding-left: 1em;
      padding-right: 1em;
      padding-top: calc(.5em - 1px);
      text-align: center;
      white-space: nowrap;
      margin: 0 3px;
      &:hover {
        background-color: #e8e8e8;
        border-color: transparent;
      }
    }
    > div {
      margin: 0 5px;
      input {
        width: 50px;
        height: 40px; 
        box-sizing: border-box;
        line-height: 40px; 
        background-color: #fff;
        border-color: #dbdbdb;
        border-radius: 4px;
        color: #363636;
        font-size: 16px;
        margin: 0 4px;
        text-align: center;
        :focus {
          border: 1px solid #dcdada !important;
        }
      }
    }
    b {
      background-color: #f5f5f5;
      border-color: transparent;
      border-color: #dbdbdb;
      border-width: 1px;
      color: #363636;
      cursor: pointer;
      justify-content: center;
      padding-bottom: calc(.5em - 1px);
      padding-left: 1em;
      padding-right: 1em;
      padding-top: calc(.5em - 1px);
      text-align: center;
      white-space: nowrap;
      font-weight: normal;
      margin: 0 0 0 2px;
      &:hover {
        background-color: #e8e8e8;
        border-color: transparent;
      }
    }
  }
}
</style>